module.exports = __webpack_public_path__ + "img/KD.6b5b30c0.png";